import { AddressFields as AddressFieldsModule } from 'modules'

export const AddressFields = AddressFieldsModule
